import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadWorkflowsV2Params = OpalApiRequestParams<'ReadWorkflowsV2'>
type ReadWorkflowsV2ResponseDocument = OpalApiResponseDocument<
  'ReadWorkflowsV2',
  200
>

export const readWorkflows = (
  params: ReadWorkflowsV2Params
): Promise<ReadWorkflowsV2ResponseDocument> => {
  const url = new URL('/workflows/v2/workflows', window.location.origin)

  url.search = queryString(params.query)

  return HttpClient()
    .get<ReadWorkflowsV2ResponseDocument>(url.toString())
    .then((res) => res.data)
}

type ReadWorkflowV2Params = OpalApiRequestParams<'ReadWorkflowV2'>
type ReadWorkflowV2ResponseDocument = OpalApiResponseDocument<
  'ReadWorkflowV2',
  200
>

export const readWorkflow = (
  params: ReadWorkflowV2Params
): Promise<ReadWorkflowV2ResponseDocument> => {
  const url = new URL(
    `/workflows/v2/workflows/${params.path.workflow_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<ReadWorkflowV2ResponseDocument>(url.toString())
    .then((res) => res.data)
}
